import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Container, Row, Col, CardGroup, Card, CardBody, Button, Input, InputGroup, InputGroupAddon} from 'reactstrap';
import { withRouter } from 'react-router-dom';

import { auth } from '../../../firebase';

import * as types from '../../../actions/actionTypes';

class Logout extends Component {
    constructor(props) {
      super(props);
    }

	componentWillMount() {
		auth.doSignOut().then(() => {
			window.localStorage.removeItem('sentToServer');
			this.context.store.dispatch(logoutSuccess());
            this.props.history.push('/login');
		});
	}

	render() {
		return null;
	}
}

function logoutSuccess() {
	return {type: types.LOG_OUT};
}

Logout.contextTypes = {
  store: PropTypes.object.isRequired
}

export default withRouter(Logout);



// WEBPACK FOOTER //
// ./src/views/Pages/Logout/Logout.js